import { createClient } from "./http";
import { env } from "../config/env";

const api = createClient(env.REPORT_BASE_URL || env.AUTH_BASE_URL);

export const ReportsService = {
  filters: () => api.get("/api/reports/filters"),
  summary: (params) => api.get("/api/reports/summary", { params }),
  userOverview: (params) => api.get("/api/reports/users/overview", { params }),
  users: (params) => api.get("/api/reports/users", { params }),
  userRanking: (params) => api.get("/api/reports/users/ranking", { params }),
  userDetail: (userId, params = {}) => api.get(`/api/reports/users/${encodeURIComponent(String(userId || ""))}/detail`, { params }),
  inactiveUsers: (params) => api.get("/api/reports/users/inactive", { params }),
  driverOverview: (params) => api.get("/api/reports/drivers/overview", { params }),
  drivers: (params) => api.get("/api/reports/drivers", { params }),
  driverDetail: (partnerId, params = {}) => api.get(`/api/reports/drivers/${encodeURIComponent(String(partnerId || ""))}/detail`, { params }),
  inactiveDrivers: (params) => api.get("/api/reports/drivers/inactive", { params }),
  catalogPerformance: (params) => api.get("/api/reports/catalog-performance", { params }),
  productPerformance: (productId, params = {}) => api.get(`/api/reports/products/${encodeURIComponent(String(productId || ""))}/performance`, { params }),
  products: (params) => api.get("/api/reports/products", { params }),
  warehouses: (params) => api.get("/api/reports/warehouses", { params }),
  driverMoney: (params) => api.get("/api/reports/driver-money", { params }),
  orderPayments: (params) => api.get("/api/reports/orders/payments", { params }),
  orderDetail: (orderId) => api.get(`/api/reports/orders/${encodeURIComponent(String(orderId || ""))}`),
  googleUsageSummary: (params) => api.get("/api/reports/google-usage/summary", { params }),
  googleUsageEvents: (params) => api.get("/api/reports/google-usage/events", { params }),
  trackGoogleClientUsage: (payload) => api.post("/api/reports/google-usage/client-event", payload),
  dataArchives: (params) => api.get("/api/reports/data-archives", { params }),
  dataArchivePreview: (runId, params) => api.get(`/api/reports/data-archives/${encodeURIComponent(String(runId))}/preview`, { params }),
  dataArchiveParts: (runId) => api.get(`/api/reports/data-archives/${encodeURIComponent(String(runId))}/parts`),

  driverAvailabilitySummary: (params) =>
  api.get("/api/reports/driver-availability/summary", { params }),

driverAvailability: (params) =>
  api.get("/api/reports/driver-availability", { params }),

driverAvailabilityUserHistory: (userId, params = {}) =>
  api.get(`/api/reports/driver-availability/user/${userId}`, { params }),
};
